import { BrowserModule } from '@angular/platform-browser'
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core'
import { LocationStrategy, HashLocationStrategy } from '@angular/common'
import { AccordionModule } from 'ngx-bootstrap/accordion'
import { BsDropdownModule } from 'ngx-bootstrap/dropdown'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { ModalModule } from 'ngx-bootstrap/modal'
import { CarouselModule } from 'ngx-bootstrap/carousel'
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker'
import { TabsModule } from 'ngx-bootstrap/tabs'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http'
import { DragDropModule } from '@angular/cdk/drag-drop'
// import { ContextMenuModule } from 'ngx-contextmenu' // TODO: Replace with Angular 18 compatible context menu
import { StadiumCamerasService } from 'app/services/stadium-cameras.service'
import { CompetitionService } from 'app/services/competition.service'
import { AppComponent } from 'app/app.component'
import { AppRoutingModule } from 'app/app-routing.module'
import { HomeComponent } from 'app/views/home/home.component'
import { MainNavbarComponent } from 'app/shared/components/main-navbar/main-navbar.component'
import { SearchComponent } from 'app/views/search/search.component'
import { DropdownMenuComponent } from 'app/shared/components/dropdown-menu/dropdown-menu.component'
import { GuideComponent } from 'app/shared/components/guide/guide.component'
import { SearchExpandComponent } from 'app/shared/components/search-expand/search-expand.component'
import {
  StoryboardItemComponent
} from 'app/shared/components/storyboard-item/storyboard-item.component'
import {
  StoryboardDashboardComponent
} from 'app/shared/components/storyboard-dashboard/storyboard-dashboard.component'
import { AssetTileComponent } from 'app/shared/components/asset-tile/asset-tile.component'
import {
  FilesDashboardComponent
} from 'app/shared/components/files-dashboard/files-dashboard.component'
import { AssetActionComponent } from 'app/shared/components/asset-action/asset-action.component'
import { DropdownSortComponent } from 'app/shared/components/dropdown-sort/dropdown-sort.component'
import { TopicItemComponent } from 'app/shared/components/topic-item/topic-item.component'
import {
  TopicsDashboardComponent
} from 'app/shared/components/topics-dashboard/topics-dashboard.component'
import {
  CompetitionJumbotronComponent
} from 'app/shared/components/competition-jumbotron/competition-jumbotron.component'
import {
  CompetitionJumbotronManageComponent
} from 'app/shared/components/competition-jumbotron-manage/competition-jumbotron-manage.component'
import {
  UsefulLinkItemComponent
} from 'app/shared/components/useful-link-item/useful-link-item.component'
import {
  UsefulLinksDashboardComponent
} from 'app/shared/components/useful-links-dashboard/useful-links-dashboard.component'
import { TopicComponent } from 'app/views/topic/topic.component'
import { TopicInfoComponent } from 'app/shared/components/topic-info/topic-info.component'
import { ModalPanelComponent } from 'app/shared/components/modal-panel/modal-panel.component'
import { ModalShareComponent } from 'app/shared/components/modal-share/modal-share.component'
import { ModalContactComponent } from 'app/shared/components/modal-contact/modal-contact.component'
import { SearchInfoComponent } from 'app/shared/components/search-info/search-info.component'
import {
  SearchDashboardComponent
} from 'app/shared/components/search-dashboard/search-dashboard.component'
import { LoginComponent } from 'app/views/login/login.component'
import { LoginFormComponent } from 'app/shared/components/login-form/login-form.component'
import { StoryboardComponent } from 'app/views/storyboard/storyboard.component'
import { GeneralViewComponent } from 'app/views/general-view/general-view.component'
import { ViewerHeaderComponent } from 'app/shared/components/viewer-header/viewer-header.component'
import {
  ViewerContentComponent
} from 'app/shared/components/viewer-content/viewer-content.component'
import {
  StoryboardHeaderComponent
} from 'app/shared/components/storyboard-header/storyboard-header.component'
import { AdminComponent } from 'app/views/admin/admin.component'
import { DocumentItemComponent } from 'app/shared/components/document-item/document-item.component'
import { SubmenuComponent } from 'app/shared/components/submenu/submenu.component'
import { FileHeaderComponent } from 'app/shared/components/file-header/file-header.component'
import { FileComponent } from 'app/views/file/file.component'
import { FileSizePipe } from 'app/shared/pipes/file-size.pipe'
import {
  DocumentRepositoryComponent
} from 'app/shared/components/document-repository/document-repository.component'
import { UsefulLinksComponent } from 'app/views/useful-links/useful-links.component'
import {
  UsefulLinkAssetComponent
} from 'app/shared/components/useful-link-asset/useful-link-asset.component'
import {
  ModalUsefulLinkComponent
} from 'app/shared/components/modal-useful-link/modal-useful-link.component'
import {
  StadiumCamera360Component
} from 'app/shared/components/stadium-camera-360/stadium-camera-360.component'
import { StadiumComponent } from 'app/views/stadium/stadium.component'
import {
  StadiumCameraComponent
} from 'app/shared/components/stadium-camera/stadium-camera.component'
import { DatePickerComponent } from 'app/shared/components/date-picker/date-picker.component'
import { OnboardingComponent } from 'app/views/onboarding/onboarding.component'
import { BgOpacityScrollDirective } from 'app/shared/directives/bg-opacity-scroll.directive'
import {
  ConfirmDialogComponent
} from 'app/shared/components/confirm-dialog/confirm-dialog.component'
import {
  AssetDataTableItemComponent
} from 'app/shared/components/asset-data-table-item/asset-data-table-item.component'
import {
  AssetDataTableComponent
} from 'app/shared/components/asset-data-table/asset-data-table.component'
import { TopicsComponent } from 'app/views/topics/topics.component'
import { ModalTopicComponent } from 'app/shared/components/modal-topic/modal-topic.component'
import { StoryboardsComponent } from 'app/views/storyboards/storyboards.component'
import {
  TextareaCounterComponent
} from 'app/shared/components/textarea-counter/textarea-counter.component'
import { SearchAdminComponent } from 'app/views/search-admin/search-admin.component'
import { InputFocusDirective } from 'app/shared/directives/input-focus.directive'
import { SwitchFilesComponent } from 'app/shared/components/switch-files/switch-files.component'
import { FilesAdminComponent } from 'app/views/files-admin/files-admin.component'
import { CompetitionComponent } from 'app/views/competition/competition.component'
import {
  CompetitionHeaderComponent
} from 'app/shared/components/competition-header/competition-header.component'
import {
  CompetitionItemComponent
} from 'app/shared/components/competition-item/competition-item.component'
import {
  CompetitionDetailsComponent
} from 'app/shared/components/competition-details/competition-details.component'
import { AssetDeleteComponent } from 'app/shared/components/asset-delete/asset-delete.component'
import {
  CompetitionLogoComponent
} from 'app/shared/components/competition-logo/competition-logo.component'
import { StadiumAdminComponent } from 'app/views/stadium-admin/stadium-admin.component'
import {
  CameraSelectorComponent
} from 'app/shared/components/camera-selector/camera-selector.component'
import { ImgDroppableDirective } from 'app/shared/directives/img-droppable.directive'
import { FilesListComponent } from './shared/components/files-list/files-list.component'
import { FilesComponent } from './views/files/files.component'
import {
  CameraInfoEditorComponent
} from 'app/shared/components/camera-info-editor/camera-info-editor.component'
import { RequestInterceptorService } from 'app/services/request-interceptor.service'
import { AuthService } from 'app/services/auth.service'
import {
  CameraDocumentsAttacherComponent
} from 'app/shared/components/camera-documents-attacher/camera-documents-attacher.component'
import {
  CameraAttachedDocumentItemComponent
} from 'app/shared/components/camera-attached-document-item/camera-attached-document-item.component'
import { CompetitionsResolver } from 'app/guards/competitions.guard'
import { CompetitionResolver } from 'app/guards/competition.guard'
import { AdminResolver } from 'app/guards/admin.guard'
import { SharepointService } from 'app/services/sharepoint.service'
import {
  ModalStoryboardComponent
} from 'app/shared/components/modal-storyboard/modal-storyboard.component'
import { ColumnSortComponent } from 'app/shared/components/column-sort/column-sort.component'
import { CoverTileComponent } from 'app/shared/components/cover-tile/cover-tile.component'
import { StoryboardsViewComponent } from 'app/views/storyboards-view/storyboards-view.component'
import { FilesService } from 'app/services/files.service'
import { StoryboardService } from 'app/services/storyboard.service'
import { TopicService } from 'app/services/topic.service'
import { PdfViewerModule } from 'ng2-pdf-viewer'
import {
  CompetitionBackgroundComponent
} from './shared/components/competition-background/competition-background.component'
import {
  StadiumBackgroundComponent
} from './shared/components/stadium-background/stadium-background.component'
import { BgImageDirective } from './shared/directives/bg-image.directive'
import { DialogHelperService } from './services/dialog-helper.service'
import { environment } from 'environments/environment'
import { GoogleTagManagerService } from './services/google-tag-manager.service'
import { MediaPlayerComponent } from './shared/components/media-player/media-player.component'
import { ModalAddDocumentComponent } from './shared/components/modal-add-document/modal-add-document.component'
import { PictureParkService } from './services/picture-park.service';
import { LoaderComponent } from './shared/components/loader/loader.component'
import { OnboardingService } from './services/onboarding.service'
import { DocumentService } from './services/document.service'
import { AssetsFactory } from './services/assets.factory.services'
import { DomElementService } from './services/dom-element.service'
import { MailService } from './services/mail.service'
import { SearchService } from './services/search.service'
import { UsefulLinkService } from './services/useful-link.service'
import { BsModalService } from 'ngx-bootstrap/modal'

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    MainNavbarComponent,
    SearchComponent,
    GuideComponent,
    DropdownMenuComponent,
    SearchExpandComponent,
    StoryboardItemComponent,
    StoryboardDashboardComponent,
    AssetTileComponent,
    FilesDashboardComponent,
    AssetActionComponent,
    DropdownSortComponent,
    TopicItemComponent,
    TopicsDashboardComponent,
    CompetitionJumbotronComponent,
    UsefulLinkItemComponent,
    UsefulLinksDashboardComponent,
    TopicComponent,
    TopicInfoComponent,
    ModalPanelComponent,
    ModalShareComponent,
    ModalContactComponent,
    SearchInfoComponent,
    SearchDashboardComponent,
    LoginComponent,
    LoginFormComponent,
    StoryboardComponent,
    GeneralViewComponent,
    ViewerHeaderComponent,
    ViewerContentComponent,
    StoryboardHeaderComponent,
    FileHeaderComponent,
    FileComponent,
    AdminComponent,
    DocumentRepositoryComponent,
    DocumentItemComponent,
    SubmenuComponent,
    FileSizePipe,
    UsefulLinksComponent,
    UsefulLinkAssetComponent,
    ModalUsefulLinkComponent,
    StadiumCamera360Component,
    StadiumComponent,
    StadiumCameraComponent,
    DatePickerComponent,
    OnboardingComponent,
    BgOpacityScrollDirective,
    ConfirmDialogComponent,
    AssetDataTableItemComponent,
    AssetDataTableComponent,
    TopicsComponent,
    ModalTopicComponent,
    StoryboardsComponent,
    TextareaCounterComponent,
    SearchAdminComponent,
    InputFocusDirective,
    SwitchFilesComponent,
    FilesAdminComponent,
    CompetitionComponent,
    CompetitionHeaderComponent,
    CompetitionItemComponent,
    CompetitionDetailsComponent,
    AssetDeleteComponent,
    CompetitionLogoComponent,
    StadiumAdminComponent,
    CameraSelectorComponent,
    ImgDroppableDirective,
    FilesListComponent,
    FilesComponent,
    CameraInfoEditorComponent,
    CameraDocumentsAttacherComponent,
    CameraAttachedDocumentItemComponent,
    ModalStoryboardComponent,
    ColumnSortComponent,
    CoverTileComponent,
    StoryboardsViewComponent,
    CompetitionBackgroundComponent,
    StadiumBackgroundComponent,
    BgImageDirective,
    CompetitionJumbotronManageComponent,
    MediaPlayerComponent,
    ModalAddDocumentComponent,
    LoaderComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AccordionModule.forRoot(),
    BsDropdownModule.forRoot(),
    FontAwesomeModule,
    ModalModule.forRoot(),
    CarouselModule.forRoot(),
    BsDatepickerModule.forRoot(),
    DragDropModule,
    BrowserAnimationsModule,
    PdfViewerModule,
    TabsModule.forRoot(),
    // ContextMenuModule.forRoot(), // TODO: Replace with Angular 18 compatible context menu
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestInterceptorService,
      multi: true
    },
    {
      provide: 'googleTagManagerId',
      useValue: environment.gtm.id
    },
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    }
  ],
  schemas: [NO_ERRORS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule {
}
